export const YES_NO_RADIO_CHOICES = [
    {
        key: 'Sì',
        value: '1',
    },
    {
        key: 'No',
        value: '0',
    },
];

export const VALORE_QUANTITA_RADIO_CHOICES = [
    {
        key: 'Valore',
        value: 'V',
    },
    {
        key: 'Quantità',
        value: 'Q',
    },
];

export const REQUIRED_STATUS = 'Campo obbligatorio';

export const INCORRECT_SUM = 'Somma errata';

export const THE_AMMOUNT_MUST_BE_ZERO = "Attenzione: l'importo deve essere 0";

export const CHECK_THE_ENTERED_VALUE = 'Attenzione: verificare il valore inserito';

export const INCONSISTENT_CHOICE = 'Attenzione: scelta incoerente';

export const INCONGRUENT_NUMBER = 'Numero non congruente';

export const INCONSISTENT_VALUE = 'Valore non coerente';

export const CHOICE_REQUIRED = 'Una scelta deve essere effettuata obbligatoriamente.';

export const ERROR_MESSAGE_CONTRIBUTO_LEGGE_59 = "Attenzione: la cooperativa non ha versato il contributo dovuto ai sensi dell'art. 11 L. 59/92";

export const IMPORTO_SUPERIORE_10_33_ERROR = "Il campo deve essere inserito obbligatoriamente quando l'importo dovuto è maggiore di 10,33 euro.";

export const VALUE_CANNOT_BE_SELECTED = 'Attenzione: Valore non selezionabile';

export const INDEXED_DB_KEY = 'allegati';

export const DATE_NOT_ALLOWED = 'Data non consentita';

export const NOT_VALID = 'Non valido';

export const INVALID_DATE = 'Data non valida.';

export const NO_FUTURE_DATE = 'Non è consentita una data futura';

/** Anno minimo consentito per le date (vincolo storico InfoPath). */
export const MIN_ANNO_DATA = 1900;
/** Anno massimo consentito: tetto molto largo, guardia anti-refuso. */
export const MAX_ANNO_DATA = 3000;

export const INCONSISTENT_SELECTION = 'Selezione incoerente';

export const INCONSISTENT_DATA = 'Dati incongruenti';

export const UNAUTHORIZED_SELECTION = 'Scelta non consentita';

export const CONFCOOPERATIVE_PEC_DOMAIN = '@pec.confcooperative.it';

export const RULE_2018_WARNING =
    'Attenzione : per le modifiche introdotte dalla legge di bilancio 2018, raccomandare fortemente alla cooperativa di definire un termine della nomina';

export const CONTACT_SYSTEM_ADMINISTRATOR = "Contattare l'amministratore di sistema.";

export const INCORRECT_VALUE = 'Valore non corretto';

// TODO: da rivedere, capire se è possibile aggiungere un prefisso custom
export const JSON_FILE_PREFIX = 'data:(?<fileType>.*);base64;(?<fileName>.*),';
